import React, { useContext, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';

import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_EXCEL, EXPORT_PDF, EXPORT_TEXT } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import { ReportsContext } from '../../../context';
import {
  DATE_RANGE_PROPS,
  LABEL_PROVIDER_PROPS,
  SHIPPING_ACCOUNT_PROPS,
  SHOW_ACCOUNT_BALANCE_HISTORY_BY_PROPS,
} from '../../../report-filters/report-paramter-input-properties';
import { PARAMETER_NAME_LABEL_PROVIDER_ID } from '../../../report-filters/report-parameter-names';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';
import messages from './messages';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_TEXT, EXPORT_CSV];

const AccountBalanceHistory = () => {
  const { labelProviderId, myAccountsForProvider } = useContext(ReportsContext);
  const hasProviderSelected = !!labelProviderId;
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const multiSelections = [
    {
      name: <FormattedMessage {...messages.selectAccount} />,
    },
    ...myAccountsForProvider,
  ];

  const shippingAccountProps = useMemo(
    () => ({
      ...SHIPPING_ACCOUNT_PROPS,
      disabled: !hasProviderSelected,
      options: myAccountsForProvider.length > 1 ? multiSelections : myAccountsForProvider,
    }),
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- multiSelections changes every render
    [hasProviderSelected, multiSelections, myAccountsForProvider],
  );

  const labelProviderProps = useMemo(
    () => ({
      ...LABEL_PROVIDER_PROPS,
      options: LABEL_PROVIDER_PROPS.options.filter((o) => o[PARAMETER_NAME_LABEL_PROVIDER_ID] !== undefined),
    }),
    [],
  );

  const filtersProps = [DATE_RANGE_PROPS, labelProviderProps, shippingAccountProps, SHOW_ACCOUNT_BALANCE_HISTORY_BY_PROPS];
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);
  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <ReportActions actions={actions} />
    </>
  );
};

export default AccountBalanceHistory;
